export default __webpack_public_path__ + "static/funneldash-99addaf82280b19c16e03eecdf5c331f.svg";